module.exports = __webpack_public_path__ + "media/images/athletes/2812-180016d84179fde0f7d7462413e0b178.png";